<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.multiyear') }}</h5>
    </template>

    <o-checkbox :label="$t('sandoz.multiyear_contract')"
                v-model="multiyearBound"
                :disabled="readonly"/>

    <o-form-group v-if="multiyearBound" :label="$t('sandoz.multiyear_contract_expiration')">
      <b-form-input v-model="item.multiyear_contract_expiration"
                    type="date"
                    :readonly="readonly"/>
    </o-form-group>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * Multi-year expectation + expiration date. Source: kam/ContractDetail.vue.
 */
export default {
  name: 'SectionMultiYear',
  mixins: [sectionMixin],
  computed: {
    multiyearBound: {
      get() {
        return !!this.item.multiyear_contract
      },
      set(v) {
        this.$set(this.item, 'multiyear_contract', v)
        if (!v) {
          this.$set(this.item, 'multiyear_contract_expiration', null)
        }
      }
    }
  }
}
</script>
